document.addEventListener("DOMContentLoaded", function () {
  const preloader = document.getElementById("site-preloader");
  const video = document.getElementById("preloader-video");
  const progressBar = document.getElementById("preloader-bar");

  if (!preloader || !video) return;

  // Video playback progress → fake loading bar
  video.addEventListener("timeupdate", function () {
    if (!progressBar || !video.duration) return;
    let pct = Math.min(100, Math.round((video.currentTime / video.duration) * 100));
    progressBar.style.width = pct + "%";
  });

  // When full page content is loaded → fade out preloader
  window.addEventListener("load", function () {
    preloader.classList.add("hidden");
    setTimeout(() => {
      if (preloader && preloader.parentNode) {
        preloader.parentNode.removeChild(preloader);
      }
    }, 700);
  });
});
